/**
 * Bridge for backward compatibility with old Swaller API
 * Allows imperative usage outside of React components
 */

// Global state for swaller methods
let globalSwallerMethods = null

// Set methods from provider (called by SwallerContext)
export const setSwallerMethods = (methods) => {
  globalSwallerMethods = methods
}

// Get methods (used by old Swaller.js)
export const getSwallerMethods = () => {
  if (!globalSwallerMethods) {
    console.warn('Swaller methods not initialized. Make sure SwallerProvider is mounted.')
    // Return dummy methods that do nothing
    return {
      success: () => {},
      error: () => {},
      warning: () => {},
      info: () => {},
      welcome: () => {},
      question: async () => false,
      input: async () => null
    }
  }
  return globalSwallerMethods
}
